<template>
  <page layout="tabbed">
    <page-header-new :title="$t('AuditLog_Title')" :breadcrumbs="breadcrumbs">
    </page-header-new>
    <page-tabs :tabs="availableTabs"></page-tabs>
  </page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import Page from '@/common/components/page/Page'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'AuditLog',
  components: { PageTabs, PageHeaderNew, Page },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
  computed: {
    availableTabs() {
      return [
        {
          title: this.$t('AuditLog_CampaignsTab'),
          route: projectRoute({ name: 'CampaignAuditLog' })
        }
      ]
    },
    breadcrumbs() {
      return [
        { label: this.$t('LeftNavigation_DataMenu') },
        { label: this.$t('LeftNavigation_AuditLog') }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audit-log/pages/AuditLog.vue